import React from "react";
import styles from "./EventCard.module.scss";
import Rhombus from "../../public/assets/icons/rhombus.svg";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";

const EventCard = ({ title, dates, hour, links }) => {
  return (
    <div className={styles.EventCard}>
      <div className={styles.lightSection}>
        <div className={styles.title}>
          <Rhombus />
          {title}
        </div>
        {dates.map((d, i) => (
          <div key={i} className={styles.lightSectionElement}>
            <span className={styles.name}>{d.name}</span>
            <div>
              <span className={styles.date}>{d.date}</span> /{" "}
              {d.day}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.darkSection}>
        <div>{hour.name}</div>
        <div>{hour.time}</div>
      </div>
      <div className={styles.buttons}>
        {links && links.length > 0 && (
          <div className={styles.linksContainer}>
            <a href={links[0]?.url} target={links[0]?.target}>
              {links[0]?.title}
            </a>
            <a href={links[1]?.url} target={links[1]?.target}>
              {links[1]?.title}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCard;
